import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'gatsby-plugin-intl'

const OrderDetails = ({ className, order }) => {
  const hasSplitLocations =
    order.loadingCompanyName ||
    order.loadingAddress ||
    order.loadingDate ||
    order.loadingTime ||
    order.unloadingCompanyName ||
    order.unloadingAddress ||
    order.unloadingDate ||
    order.unloadingTime

  const cargoDetails = [order.container, order.shipowner || order.cargoType]
    .filter(Boolean)
    .join(', ')

  return (
    <div className={className}>
      <Text>
        {order.transportationType ? (
          <>
            <FormattedMessage id={`common.${order.transportationType}`} />
            {', '}
          </>
        ) : (
          ''
        )}
        {!hasSplitLocations && order.loadingUnloadingCompanyName
          ? `${order.loadingUnloadingCompanyName}, `
          : ''}
        {!hasSplitLocations && order.loadingUnloadingAddress
          ? `${order.loadingUnloadingAddress}, `
          : ''}
        {!hasSplitLocations && order.loadingUnloadingDate ? (
          <span>{`${order.loadingUnloadingDate}, `}</span>
        ) : (
          ''
        )}
        {!hasSplitLocations && order.loadingUnloadingTime ? (
          <span>{`${order.loadingUnloadingTime}, `}</span>
        ) : (
          ''
        )}
        {hasSplitLocations && order.loadingCompanyName
          ? `${order.loadingCompanyName}, `
          : ''}
        {hasSplitLocations && order.loadingAddress
          ? `${order.loadingAddress}, `
          : ''}
        {hasSplitLocations && order.loadingDate ? (
          <span>{`${order.loadingDate}, `}</span>
        ) : (
          ''
        )}
        {hasSplitLocations && order.loadingTime ? (
          <span>{`${order.loadingTime}, `}</span>
        ) : (
          ''
        )}
        {hasSplitLocations && order.unloadingCompanyName
          ? `${order.unloadingCompanyName}, `
          : ''}
        {hasSplitLocations && order.unloadingAddress
          ? `${order.unloadingAddress}, `
          : ''}
        {hasSplitLocations && order.unloadingDate ? (
          <span>{`${order.unloadingDate}, `}</span>
        ) : (
          ''
        )}
        {hasSplitLocations && order.unloadingTime ? (
          <span>{`${order.unloadingTime}, `}</span>
        ) : (
          ''
        )}
        {cargoDetails ? `${cargoDetails}, ` : ''}
        {order.forwarder.company ? `${order.forwarder.company} ` : ''}
        {order.forwarder.name ? `(${order.forwarder.name})` : ''}
      </Text>
    </div>
  )
}

export default styled(OrderDetails)`
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  min-height: 20px;
  line-height: 1;
`

const Text = styled.span`
  display: inline;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1;
  color: ${({ theme }) => theme.colors.ebonyClay.hex()};
  span {
    color: ${({ theme }) => theme.colors.ebonyClay.alpha(0.6).hex()};
  }
`
